import { PUBLIC_DB_ENDPOINT } from '$env/static/public';

export class Db {
	constructor(table) {
		this.filters = [];
		this.params = {};
		this.operation = '';
		this.table = table;
		this.lim = 100;
		this.page = 0;
	}

	textsearch(name, value) {
		this.filters.push({
			param1: name,
			param2: value,
			type: typeof value,
			function: 'ts'
		});
		return this;
	}
	startsWith(name, value) {
		this.filters.push({
			param1: name,
			param2: value,
			type: typeof value,
			function: 'sw'
		});
		return this;
	}
	ne(name, value) {
		this.filters.push({
			param1: name,
			param2: value,
			type: typeof value,
			function: 'ne'
		});
		return this;
	}
	eq(name, value) {
		this.filters.push({
			param1: name,
			param2: value,
			type: typeof value,
			function: 'eq'
		});
		return this;
	}

	descending(column) {
		this.params['order'] = { column: column, direction: -1 };
		return this;
	}

	ascending(column) {
		this.params['order'] = { column: column, direction: 1 };
		return this;
	}

	static query(table) {
		let temp = new Db(table);
		return temp;
	}

	static async get(table, id) {
		let temp = new Db(table);
		temp.filters.push({
			function: 'eq',
			param1: '_id',
			param2: id,
			type: typeof id
		});
		temp.params['limit'] = 1;
		temp.operation = 'get';

		const response = await fetch(PUBLIC_DB_ENDPOINT, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				table: temp.table,
				filters: temp.filters,
				params: temp.params,
				operation: temp.operation
			})
		});

		if (response.status == 200) {
			let res = response.json();
			return res.then((result) => {
				return result;
			});
		} else {
			return null;
		}
	}

	static async update(table, item) {
		let temp = new Db(table);
		this.operation = 'upsert';
		// console.log({"table":table,"filters":temp.filters,"params":temp.params,"operation":temp.operation});
		const response = await fetch(PUBLIC_DB_ENDPOINT, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ table: table, operation: 'upsert', item: item })
		});
		let res = await response.json();
		return res;
	}
	static async insert(table, item) {
		let temp = new Db(table);
		this.operation = 'insert';
		// console.log({"table":temp.table,"filters":temp.filters,"params":temp.params,"operation":temp.operation});
		const response = await fetch(PUBLIC_DB_ENDPOINT, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ table: table, operation: 'upsert', item: item })
		});
		let res = await response.json();

		return res;
	}
	async find(operation) {
		if (arguments.length == 0 || this.operation == '') {
			this.operation = 'find';
		}
		// console.log("page",this.page,this.lim);

		if (this.page > 0) {
			this.params['page'] = this.page;
		}

		this.params['limit'] = this.lim;

		// console.log({"table":this.table,"filters":this.filters,"params":this.params,"operation":this.operation});
		const response = await fetch(PUBLIC_DB_ENDPOINT, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				table: this.table,
				filters: this.filters,
				params: this.params,
				operation: this.operation
			})
		});
		let res = await response.json();
		this.items = res.items;
		// console.log("res:",res);
		let r = new QueryResult(this);
		r.items = res.items;

		return r;
	}
	limit(number) {
		this.lim = number;

		return this;
	}
}

export class QueryResult {
	constructor(wd) {
		// console.log("wd",wd,wd.items);
		this.items = wd.items;
		this.page = wd.page;
		this.pageSize = wd.lim;
		this.more = false;
		this.data = wd;
		//
		this.currentPage = 0;
		this.length = 0;
		this.pageSize = 0;
		this.totalCount = 0;
		this.totalPages = 0;
	}

	hasPrev() {}

	next() {
		this.data.page = this.data.page + 1;
		let res = this.data.find();
		return res;
	}

	prev() {}

	hasNext() {
		// console.log("hasNext",this.wixData.length,this.wixData.lim);
		if (this.data.items.length % this.data.lim == 0) {
			// console.log("hasNext is true");
			return true;
		}
	}
}
